import {
  AccentIcon,
  AccentIconShapeEnum,
} from '@delmonicos/shared-design-system-react/src/components/accent-icon/accent-icon';
import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import { Divider } from '@delmonicos/shared-design-system-react/src/components/divider/divider';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { ChargePointStatus } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpp/src/enums/charge-point-status.enum';
import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useChargePointChannelContext } from '@app/feature/charge-point/charge-point.context';
import { mapStatusToGenericConnectorStatus } from '@app/feature/charge-point/helper/connector-status.helper';
import { mapTypeToGenericConnectorType } from '@app/feature/charge-point/helper/connector-type.helper';

import * as css from './channel-card.module.scss';

export const ChannelCardComponent = (): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const channel = useChargePointChannelContext();

  // RENDER ////////////////////////////////////////////////////////////////////

  const computedStatus = mapStatusToGenericConnectorStatus(
    channel.computedStatus || ChargePointStatus.Unavailable,
  );

  if (channel.physicalSockets.length === 0) {
    return (
      <Card className={css.connectorCard} gap={GapEnum.M}>
        <Card.FullWidth
          className={classNames(
            [computedStatus.color],
            css.cardHeader,
            css.cardHeader,
          )}
        />
        <Stack
          direction="column"
          gap={GapEnum.S}
          alignItems="center"
          justifyContent="center">
          <Stack gap={GapEnum.XS}>
            {/* TODO: Improve rendering of this unexpected case */}
            <Text bold>
              This channel is not associated with any physical socket
            </Text>
          </Stack>
        </Stack>
      </Card>
    );
  }

  return (
    <Card className={css.connectorCard} gap={GapEnum.M}>
      <Card.FullWidth
        className={classNames(
          [computedStatus.color],
          css.cardHeader,
          css.cardHeader,
        )}
      />
      <Stack direction="column" gap={GapEnum.S} alignItems="center">
        {channel.physicalSockets.map((physicalSocket, index) => {
          const connectorType = mapTypeToGenericConnectorType(
            physicalSocket.standard,
          );
          const status = mapStatusToGenericConnectorStatus(
            physicalSocket.ocppStatus,
          );
          return (
            <>
              {index !== 0 && <Divider />}
              <Stack direction="column" alignItems="center" gap={GapEnum.XS}>
                <AccentIcon
                  icon={connectorType.icon}
                  variant={status.accentVariant}
                  shape={AccentIconShapeEnum.Round}
                />
                <Text className={css.name} bold>
                  {t(
                    `delmonicos-shared-sdk.ocpi-protocol-enums.connector-type-alt.${connectorType.name}`,
                  )}
                </Text>
              </Stack>
            </>
          );
        })}
      </Stack>
    </Card>
  );
};
